import React, { createRef } from 'react';
import classnames from 'classnames';
import moment from 'moment';

import Availability from '../availability';
import Schedule from '../schedule';
import Loading from '../../common/Loading';
import CustomDropDown from './DropdownMenu/customDropdown';
import utils from '../../../lib/utils';

import './index.scss';
const business_working_hours = [
    {
        "start": "23:59:00",
        "label": "12AM",
        "end": "00:59:00"
    },
    {
        "start": "00:59:00",
        "label": "01AM",
        "end": "01:59:00"
    },
    {
        "start": "01:59:00",
        "label": "02AM",
        "end": "02:59:00"
    },
    {
        "start": "02:59:00",
        "label": "03AM",
        "end": "03:59:00"
    },
    {
        "start": "03:59:00",
        "label": "04AM",
        "end": "04:59:00"
    },
    {
        "start": "04:59:00",
        "label": "05AM",
        "end": "05:59:00"
    },
    {
        "start": "05:59:00",
        "label": "06AM",
        "end": "06:59:00"
    },
    {
        "start": "06:59:00",
        "label": "07AM",
        "end": "07:59:00"
    },
    {
        "start": "07:59:00",
        "label": "08AM",
        "end": "08:59:00"
    },
    {
        "start": "08:59:00",
        "label": "09AM",
        "end": "09:59:00"
    },
    {
        "start": "09:59:00",
        "label": "10AM",
        "end": "10:59:00"
    },
    {
        "start": "10:59:00",
        "label": "11AM",
        "end": "11:59:00"
    },
    {
        "start": "11:59:00",
        "label": "12PM",
        "end": "12:59:00"
    },
    {
        "start": "12:59:00",
        "label": "01PM",
        "end": "13:59:00"
    },
    {
        "start": "13:59:00",
        "label": "02PM",
        "end": "14:59:00"
    },
    {
        "start": "14:59:00",
        "label": "03PM",
        "end": "15:59:00"
    },
    {
        "start": "15:59:00",
        "label": "04PM",
        "end": "16:59:00"
    },
    {
        "start": "16:59:00",
        "label": "05PM",
        "end": "17:59:00"
    },
    {
        "start": "17:59:00",
        "label": "06PM",
        "end": "18:59:00"
    },
    {
        "start": "18:59:00",
        "label": "07PM",
        "end": "19:59:00"
    },
    {
        "start": "19:59:00",
        "label": "08PM",
        "end": "20:59:00"
    },
    {
        "start": "20:59:00",
        "label": "09PM",
        "end": "21:59:00"
    },
    {
        "start": "21:59:00",
        "label": "10PM",
        "end": "22:59:00"
    },
    {
        "start": "22:59:00",
        "label": "11PM",
        "end": "23:59:00"
    },
    {
        "start": "23:59:00",
        "label": "12AM",
        "end": "00:59:00"
    }
]
export default class DentalSchedulePreview extends React.Component {
    constructor() {
        super();
        this.state = {
            view:'availability',
            selected_service:'',
            selected_staff:'',
            selected_resource:'',
            location_id:'',
            service_dropdwon:[],
            staff_dropdown:[],
            operatory_dropdwon:[],
            serviceDropdownVisibility:false,
            staffDropdownVisibility:false,
            operatoryDropdownVisibility:false,
            loading:false,
            initDate:new Date(),
            no_of_days:7,
        };
      } 
      availabilityChild = createRef();
      scheduleChild = createRef();

    componentDidMount(){
          const { auth, business } = this.props;
          const {  studio_id } = auth;
          const bzid = this.props.business.id || studio_id;
          
          if(!business?.businessDetailsFetched && bzid && utils.isEmptyObject(business?.details) ){
            this.props.getBusinessDetails(bzid);
          }
          if(business?.businessDetailsFetched && !utils.isEmptyObject(business?.details)){
            let all_staff_id = [ ];
            for(let i=0;i<business?.details?.staffs.length;i++){
                all_staff_id.push(business?.details?.staffs[i].id);
            }
            const  all_staff = [{
                name:'All',
                id : 'ALL_STAFF'
            }];
            const staff_dropdown = [...all_staff , ...business?.details?.staffs];

            let all_resource_id = [ ];
            for(let i=0;i<business?.details?.resources.length;i++){
                all_resource_id.push(business?.details?.resources[i].id);
            }
            const  all_resource = [{
                name:'All',
                id : 'ALL_RESOURCE'
            }];
            const operatory_dropdwon = [...all_resource , ...business?.details?.resources];
            //const business_working_hours = this.generateWorkingHours(business?.details?.data?.business_working_hours);
            this.getServiceList();
            this.setState({
                selected_service : business?.details?.services.filter(service=>service.kind==='SESSION')[0]?.id,
                selected_staff : all_staff_id ,
                location_id : business?.details?.locations[0]?.id,
                selected_resource : all_resource_id,
                staff_dropdown,
                operatory_dropdwon,
                //business_working_hours
            }) 
          }
    } 

    componentWillReceiveProps(nextProps){
        if(!utils.isEmptyObject(nextProps?.business?.details) && nextProps?.business?.details!== this.props?.business?.details){
            const {business } = nextProps;
            let all_staff_id = [ ];
            for(let i=0;i<business?.details?.staffs.length;i++){
                all_staff_id.push(business?.details?.staffs[i].id);
            }
            const  all_staff = [{
                name:'All',
                id : 'ALL_STAFF'
            }];
            const staff_dropdown = [ ...all_staff , ...business?.details?.staffs];
            let all_resource_id = [ ];
            for(let i=0;i<business?.details?.resources.length;i++){
                all_resource_id.push(business?.details?.resources[i].id);
            }
            const  all_resource = [{
                name:'All',
                id : 'ALL_RESOURCE'
            }];
            this.getServiceList();
            const operatory_dropdwon = [...all_resource, ...business?.details?.resources];
            //const business_working_hours = this.generateWorkingHours(business?.details?.data?.business_working_hours);
            this.setState({
                    selected_service :  nextProps?.business?.details?.services.filter(service=>service.kind==='SESSION')[0]?.id,
                    selected_staff : all_staff_id ,
                    location_id : nextProps?.business?.details?.locations[0]?.id,
                    selected_resource : all_resource_id,
                    staff_dropdown,
                    operatory_dropdwon,
                    //business_working_hours
            })
        }
    }
    generateWorkingHours=(business_working_hours)=>{
        const working_hours = Object.values(business_working_hours);
        let start_time = moment(working_hours[0].start,'HH:mm:ss');
        let end_time = moment(working_hours[0].end,'HH:mm:ss');
        for(let i=1;i<working_hours.length;i++){
            start_time = moment(working_hours[i].start,'HH:mm:ss').isBefore(start_time)?moment(working_hours[i].start,'HH:mm:ss'):start_time;
            end_time = moment(working_hours[i].end,'HH:mm:ss').isAfter(end_time)?moment(working_hours[i].end,'HH:mm:ss'):end_time;
        }
        start_time = moment(start_time).minutes()>0? moment(start_time).subtract(60-moment(start_time).minutes(),'minutes'):start_time;
        end_time = moment(end_time).minutes()>0? moment(end_time).add(60-moment(end_time).minutes(),'minutes'):end_time;
        let working_hours_array = [];
        do{
            working_hours_array.push({start:moment(start_time).subtract(1,'minutes').format('HH:mm:ss'),label: moment(start_time).format('hhA'), end:moment(start_time).add(59,'minutes').format('HH:mm:ss')})
            start_time = moment(start_time).add(1,'hour');
        }while(moment(start_time).isBefore(moment(end_time)))
        return working_hours_array;
    }
    onViewTypeChange=(viewType)=>{
        const { selected_service,view } = this.state;
        this.setState({
            view: viewType,
            ...( (selected_service === 'OTHER' && view === 'schedule') &&{selected_service :  this.props?.business?.details?.services.filter(service=>service.kind==='SESSION')[0]?.id})
        },()=>{this.getServiceList()})
    }
    onDropdownChange=(event)=>{
            console.log('EVENT',event);
            const { business } = this.props;
            let all_id = [ ];
            let field_value = event.target.value;
            if(event.target.value==='ALL_STAFF'){
                for(let i=0;i<business?.details?.staffs.length;i++){
                    all_id.push(business?.details?.staffs[i].id);
                 }
                 field_value = all_id;
                 console.log('all_id 1', all_id, field_value);
            }else if(event.target.value==='ALL_RESOURCE'){
                for(let i=0;i<business?.details?.resources.length;i++){
                    all_id.push(business?.details?.resources[i].id);
                }
                field_value = all_id;
                console.log('all_id 2', all_id, field_value);
            }
        
        this.setState({
            [event.target.name]: field_value
        })
    }
    getNameFromId=(id,key)=>{
        if(this.props?.business?.details && (key !=='staff_dropdown' || key !=='operatory_dropdwon')){
           return this.props?.business?.details[key] ? this.props.business.details[key].filter(data=>data.id===id):[];
        }
        return [];
    }
    getStaffName=(id)=>{
            const { staff_dropdown } = this.state;
            if(typeof id === 'object'){
                return [{
                    name:'All',
                    id : 'ALL_RESOURCE'
                }];
            }else{
                return staff_dropdown.filter(data=>data.id===id);
            } 
            
    }

    getServiceName=(id)=>{
        const { service_dropdwon } = this.state;
        return service_dropdwon.filter(data=>data.id===id);
    }

    getOperatoryName=(id)=>{
        const { operatory_dropdwon } = this.state;
        if(typeof id === 'object'){
            return [{
                name:'All',
                id : 'ALL_STAFF'
            }];
        }else{
            return operatory_dropdwon.filter(data=>data.id===id);
        } 
        
    }

    fetchAvailability =(time_span)=>{
        const { selected_service, selected_staff, selected_resource,location_id } = this.state;
        const { business } = this.props;
        let requestData = {};
        requestData.business_id = business.id;
        requestData.service_id = selected_service;
        requestData.staff_ids = typeof selected_staff === "object"? selected_staff:[selected_staff];
        requestData.location_id = location_id;
        requestData.resource_ids= typeof selected_resource === "object"? selected_resource:[selected_resource];
        requestData.time_span = time_span;
        this.setState({initDate: time_span.start_date, loading:true});
        this.props.getDentalSchedules(requestData);
    }

    setServiceDropdownVisibility=()=>{
        this.setState({
            serviceDropdownVisibility: !this.state.serviceDropdownVisibility,
        });
    }
    setStaffDropdownVisibility=()=>{
        this.setState({
            staffDropdownVisibility: !this.state.staffDropdownVisibility,
        });
    }
    setOperatoryDropdownVisibility=()=>{
        this.setState({
            operatoryDropdownVisibility: !this.state.operatoryDropdownVisibility,
        });
    }
    getServiceList=()=>{
        const { services } = this.props?.business?.details;
        const { view } = this.state;
        if(!utils.isEmptyObject(services)){
        let session_service=  services?.filter(service=>service.kind==='SESSION');
        if(view!=='availability'){
            session_service.push({
                id:'OTHER',
                name:'Other Services'
            })
        }
        this.setState({
            service_dropdwon: session_service
        })
        }
    }

    onJumpToday=()=>{
        const { view } = this.state;
        if(view ==='availability'){
        this.availabilityChild.current.jumpToToday();
        }else{
        this.scheduleChild.current.jumpToToday();  
        }
    }
    render(){
        const { business, softwares, auth } = this.props;
        const { studio_id } = auth;
        const bzid = business.id || studio_id;  
        const { serviceDropdownVisibility, staffDropdownVisibility, operatoryDropdownVisibility, selected_service, selected_staff, selected_resource,location_id, staff_dropdown, operatory_dropdwon, service_dropdwon, view, loading, initDate} = this.state;
        const pmsList = business?.details?.locations?.length>0? business.details?.locations[0].location_metadata?.associated_pms:null;
        console.log('service_dropdwon',service_dropdwon);
        return(
            <div className="schedule">
        {(softwares.studioId !== "" || bzid !== '')?
           (<>
            <div className='schedule_title'>
                    <div className="schedule_title_content">
                        <div className="title">Schedule Preview</div>
                        <div className="period-filter">
                            <div className={classnames('period-filter_value',{'active': view ==='availability'})} onClick={()=>this.onViewTypeChange('availability')}>Available</div>
                            <div className={classnames('period-filter_value',{'active': view ==='schedule'})} onClick={()=>this.onViewTypeChange('schedule')}>Scheduled</div>
                        </div>
                    </div>
                    <div className='serviceschedule_title_pms'><div>{pmsList}</div><div className='serviceschedule_title_pms_synctime'>Last updated: {moment(business?.details?.last_sync_time).fromNow()}</div></div>
                </div>
            { (!selected_service && !selected_staff && !selected_resource)?
            (<div className="schedule_loader">
            <Loading />
            </div>):
            (
                <div className="schedule_content">
                    <div className="schedule_content_filters">
                        <div className="dropdown-group">
                            <div className="filter">
                                <label htmlFor="account_type">Service type</label>
                                <div className="drop-down margin-right">
                                        <a
                                            href="#"
                                            onClick={(event) => {
                                            event.stopPropagation();
                                            event.preventDefault();
                                            this.setServiceDropdownVisibility(true);
                                            }}
                                            className="selected-value"
                                        >
                                            <span className="value-display">{this.getServiceName(selected_service,'services')[0]?.name}</span>{' '}
                                            <i className="material-icons">arrow_drop_down</i>
                                        </a>
                                        <CustomDropDown
                                            visibility={serviceDropdownVisibility}
                                            position="tl"
                                            onVisibilityChange={(visibility) => {
                                            this.setServiceDropdownVisibility(visibility);
                                            }}
                                            selectedOption={selected_service}
                                            className="menu__dropdown"
                                            dropdownList={service_dropdwon}
                                            onChange={(event) => {
                                            this.onDropdownChange({target:{name:'selected_service', value:event}});
                                            }}
                                        />
                                </div>
                            </div>
                            <div className="filter">
                                <label htmlFor="account_type">Provider</label>
                                {/* <div className="select-group_container">
                                    <select name="Operatory" className="select-box" value={selected_staff} name={'selected_staff'} onChange={this.onDropdownChange}>
                                        {staff_dropdown?.map(staff => {
                                                return <option value={staff.id} >{staff.name}</option>
                                        })}
                                    </select>
                                    <i className="material-icons">arrow_drop_down</i>
                                </div> */}
                                <div className="drop-down margin-right">
                                        <a
                                            href="#"
                                            onClick={(event) => {
                                            event.stopPropagation();
                                            event.preventDefault();
                                            this.setStaffDropdownVisibility(true);
                                            }}
                                            className="selected-value"
                                        >
                                            <span className="value-display">{this.getStaffName(selected_staff)[0]?.name}</span>{' '}
                                            <i className="material-icons">arrow_drop_down</i>
                                        </a>
                                        <CustomDropDown
                                            visibility={staffDropdownVisibility}
                                            position="tl"
                                            onVisibilityChange={(visibility) => {
                                            this.setStaffDropdownVisibility(visibility);
                                            }}
                                            selectedOption={selected_staff}
                                            className="menu__dropdown"
                                            dropdownList={staff_dropdown}
                                            onChange={(event) => {
                                            this.onDropdownChange({target:{name:'selected_staff', value:event}});
                                            }}
                                        />
                                </div>
                            </div>
                            {operatory_dropdwon?.length>1 && 
                            <div className="filter">
                            <label htmlFor="Operatory">Operatory</label>
                            {/* <div className="select-group_container">
                                <select name="Operatory" className="select-box" value={selected_resource} name={'selected_resource'} onChange={this.onDropdownChange}>
                                    {operatory_dropdwon?.map(resource => {
                                            return <option value={resource.id} >{resource.name}</option>
                                    })}
                                </select>
                                <i className="material-icons">arrow_drop_down</i>
                            </div> */}
                             <div className="drop-down margin-right">
                                    <a
                                        href="#"
                                        onClick={(event) => {
                                        event.stopPropagation();
                                        event.preventDefault();
                                        this.setOperatoryDropdownVisibility(true);
                                        }}
                                        className="selected-value"
                                    >
                                        <span className="value-display">{this.getOperatoryName(selected_resource)[0]?.name}</span>{' '}
                                        <i className="material-icons">arrow_drop_down</i>
                                    </a>
                                    <CustomDropDown
                                        visibility={operatoryDropdownVisibility}
                                        position="tl"
                                        onVisibilityChange={(visibility) => {
                                        this.setOperatoryDropdownVisibility(visibility);
                                        }}
                                        selectedOption={selected_resource}
                                        className="menu__dropdown"
                                        dropdownList={operatory_dropdwon}
                                        onChange={(event) => {
                                        this.onDropdownChange({target:{name:'selected_resource', value:event}});
                                        }}
                                    />
                            </div>
                        </div>}
                        </div>
                        <div className="btn-group">
                            <div className="filter">
                                <button className="jump-today" onClick={this.onJumpToday}>
                                    <div className="jump-today_container"><span className="blue-dot"></span> <span>Today</span> </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    {view ==='availability' ?
                    (
                        <Availability business_working_hours={business_working_hours} selected_service = {selected_service} selected_staff = {selected_staff} selected_resource = {selected_resource} location_id = {location_id} loading={loading} initDate={initDate} {...this.props}  ref={this.availabilityChild}></Availability>
                    )
                    :(
                        <Schedule conversations = {this.props.conversations} business_working_hours={business_working_hours} selected_service = {selected_service} selected_staff = {selected_staff} selected_resource = {selected_resource} location_id = {location_id} getNameFromId={this.getNameFromId} loading={loading} initDate={initDate} {...this.props} ref={this.scheduleChild}></Schedule>  
                    )}
                </div>
            )}
            </>):
            (<div className="non-authenticated">
            Complete practice management software authorization under <a className="setup-link" href="/#/app/setup/summary">AI Setup &gt; Setup</a>, to start defining your schedule.
            </div>)}
            </div>
          )
      }

}